export default "__VITE_ASSET__C1GxgN$G__"